<script lang="ts" setup>
import type { DataLayerItem } from '~layers/composables/useDataLayer'

const {
  search,
  products,
  totalProducts,
  loading,
} = useQuickSearch()

const { viewItemList } = useDataLayer()
const dataLayerOverrides = computed<Partial<DataLayerItem>>(() => ({ item_list_name: 'quick-search', item_list_id: search.value }))

watch(loading, () => {
  if (!loading.value) {
    // searchDialogOpen.value = true
    if (products.value.length > 0) {
      viewItemList(products.value, dataLayerOverrides.value)
    }
  }
})
</script>

<template>
  <div
    class="search__group search__group--products"
    :aria-label="$t('Products')"
    role="group"
  >
    <div class="search__heading">
      <span aria-hidden="true">{{ $t('Products') }} ({{ totalProducts }})</span>
      <AppLink
        :to="`/search/?q=${search}`"
        class="search__link-all"
        :aria-label="$t('View all results for {search}', { search })"
      >
        {{ $t('View all') }}
      </AppLink>
    </div>

    <div
      v-if="products?.length > 0"
      class="search__products"
    >
      <SearchProductTile
        v-for="product in products"
        :key="product"
        :data-layer-overrides="dataLayerOverrides"
        :product="product"
        :parameter="`?q=${search}`"
        class="search__products-item"
        list="Search"
      />
    </div>
    <div
      v-else
      class="search__no-results"
    >
      {{ $t('No products found') }}
    </div>

    <!-- <pre>totalProducts: {{ totalProducts }}</pre> -->
    <!-- <pre>products: {{ products }}</pre> -->
  </div>
</template>

<style>
@import url("~layers/components/Search/ResultProducts.css");
</style>
